import { useContext } from "react";
import { AudioContext } from "../../audio-context";

/**
 * Custom hook for accessing the audio context.
 * @returns {object} Audio context.
 */
const useAudioContext = () => useContext(AudioContext);

export default useAudioContext;
